module.exports = __webpack_public_path__ + "static/img/superman2.86bd6e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/nxzw/superman2.png
// module id = /Dyd
// module chunks = 0